import { render, staticRenderFns } from "./PuhuoTable.vue?vue&type=template&id=1e0d695f&scoped=true"
import script from "./PuhuoTable.vue?vue&type=script&lang=js"
export * from "./PuhuoTable.vue?vue&type=script&lang=js"
import style0 from "./PuhuoTable.vue?vue&type=style&index=0&id=1e0d695f&prod&lang=scss&scoped=true"
import style1 from "./PuhuoTable.vue?vue&type=style&index=1&id=1e0d695f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0d695f",
  null
  
)

export default component.exports